<template>
  <div class="page-width-warpper">
    <div class="news-warpper">
      <div style="flex: 1">
        <div class="newsDetail">
          <div class="title">{{ pageData.title }}</div>
          <div class="time">
            时间：{{ pageData.createTime }} 点击：{{ pageData.cmsViewNum }}次
          </div>
          <div class="info" v-if="!!pageData.content">
            <div v-html="pageData.content"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { pageByCode, newsDetail } from "@/api/index";

export default {
  name: "SearchDetail",
  data() {
    return {
      hotList: [],
      pageData: {},
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(val) {
        this.getData(val.query.id);
      },
    },
  },
  created() {
    this.getData(this.$route.query.id);
  },
  methods: {
    getData(id) {
      newsDetail(id).then((res) => {
        this.pageData = res.data;
        if (this.pageData.content.indexOf("<table") !== -1) return;
        this.pageData.content = this.pageData.content.replace(
          /\t/g,
          "<span style='padding-left:1em;'></span>"
        );
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css
.news-warpper {
  display: flex;
  padding: 12px 0;
}
.newsDetail {
  border: 1px solid #ddd;
  .title {
    text-align: center;
    font-size: 16px;
    color: $main-color;
    font-weight: bold;
    padding: 20px 20px 0;
  }
  .time {
    text-align: center;
    color: #666;
    font-size: 12px;
    padding: 10px 0;
  }
  .info {
    padding: 5px 10px;
    // white-space: pre;
    // div {
    //   white-space: pre;
    // }
    ::v-deep a {
      text-decoration: underline;
      color: #0000ee;
    }

    ::v-deep img {
      max-width: 100%;
    }
  }
}
</style>
